import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { blogimg2, imguser } from "../../components/imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { message } from "antd";
import { BASE_URL_IMAGE } from "../../config/api";
import { jwtDecode } from "jwt-decode";
import { fetchUserById, updateUserAtProfile } from "../../services/userService";

const EditUser = () => {
  const navigate = useNavigate();
  const [fileName, setFileName] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(false);

  // Update initial state to include all fields
const [userData, setUserData] = useState({
  user_name: '',
  user_email: '',
  user_contact: '',
  user_status: '',
  user_department: '',
  user_biography: '',
  user_designation: '',
  user_qualification: '',
  user_teaching_experience: '',
  user_industrial_experience: '',
  user_specialization: '',
  user_international_publication: '',
  user_domestic_publication: '',
  user_research_project: '',
  user_facebook_link: '',
  user_linkedin_link: '',
  user_profile_img: '',
  
});

  // Department options
  const departmentOptions = [
    { value: 1, label: "Computer Science & Engineering" },
    { value: 2, label: "Electrical Engineering" },
    { value: 3, label: "Mechanical Engineering" },
    { value: 4, label: "Civil Engineering" },
    { value: null, label: "None" }
  ];

  const [selectedDepartment, setSelectedDepartment] = useState(null);

  useEffect(() => {
    const fetchAndSetUser = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const user = await fetchUserById(decoded.id);
          setUserData(user);
          
          // Set department selection after data loads
          if (user.user_department) {
            const dept = departmentOptions.find(
              opt => opt.label === user.user_department
            );
            setSelectedDepartment(dept);
          }
        } catch (error) {
          console.error("Error fetching user:", error);
          message.error("Failed to load user data");
        }
      }
    };

    fetchAndSetUser();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDepartmentChange = (selectedOption) => {
    setSelectedDepartment(selectedOption);
    setUserData(prev => ({
      ...prev,
      user_department: selectedOption ? selectedOption.label : "",
    }));
  };

  const handleStatusChange = (e) => {
    setUserData(prev => ({
      ...prev,
      user_status: e.target.value,
    }));
  };

  const loadFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setSelectedImage(file);
      const imageUrl = URL.createObjectURL(file);
      setUserData(prev => ({
        ...prev,
        user_profile_img: imageUrl
      }));
    }
  };

  const removeImage = () => {
    setFileName('');
    setSelectedImage(null);
    setUserData(prev => ({
      ...prev,
      user_profile_img: blogimg2
    }));
  };

  // Corrected handleSubmit
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  // Validate required fields
  if (!userData.user_name || !userData.user_email || !userData.user_contact) {
    message.error('Name, email and contact are required');
    setLoading(false);
    return;
  }

  try {
    const formData = new FormData();
    
    // Append all fields with proper values
    Object.keys(userData).forEach(key => {
      // Skip profile image if not changed
      if (key === 'user_profile_img' && !selectedImage) return;
      
      // Convert undefined/null to empty string for all fields
      const value = userData[key] ?? '';
      formData.append(key, value);
    });

    // Append image file if selected
    if (selectedImage) {
      formData.append('profile_img', selectedImage);
    }

    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    
    await updateUserAtProfile(decoded.id, formData);
    message.success("Profile updated successfully");
    navigate('/profile');
  } catch (error) {
    console.error("Update error:", error);
    message.error(error.message || "Update failed");
  } finally {
    setLoading(false);
  }
};

  const breadcrumbItems = [
    { label: "User", path: "/list-users" },
    { label: "Edit User" },
  ];

  return (
   <>
      <Helmet>
        <title>Edit Member | CRM Jnec</title>
      </Helmet>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <Breadcrumb items={breadcrumbItems} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Staff Details</h4>
                          </div>
                        </div>
                        
                        {/* Profile Image Section */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-top-form">
                            <label className="local-top">Profile Image</label>
                            <div className="d-flex align-items-center gap-4 mb-3">
                              <div className="avatar-upload-preview">
                                <img 
                                  src={
                                    userData.user_profile_img 
                                      ? userData.user_profile_img.includes('blob:') 
                                        ? userData.user_profile_img 
                                        : `${BASE_URL_IMAGE}/uploads/userProfiles/${userData.user_profile_img}`
                                      : imguser
                                  } 
                                  alt="Profile" 
                                  className="img-thumbnail rounded-circle"
                                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                />
                              </div>
                              <div className="d-flex flex-column gap-2">
                                <div className="settings-btn upload-files-avator">
                                  <input
                                    type="file"
                                    accept="image/*"
                                    name="profile_img"
                                    id="profile_img"
                                    onChange={loadFile}
                                    className="hide-input"
                                  />
                                  <label htmlFor="profile_img" className="upload">
                                    <FeatherIcon icon="upload" className="me-2" />
                                    {fileName ? 'Change Image' : 'Upload New'}
                                  </label>
                                </div>
                                {/* {(fileName || (userData.user_profile_img && !userData.user_profile_img.includes(imguser))) && (
                                  <button 
                                    type="button" 
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={removeImage}
                                  >
                                    <FeatherIcon icon="trash-2" className="me-2" />
                                    Remove
                                  </button>
                                )} */}
                              </div>
                            </div>
                            {fileName && (
                              <div className="text-muted small">
                                Selected file: {fileName}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Status */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group select-gender">
                            <label className="gen-label">Status <span className="login-danger">*</span></label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="user_status"
                                  className="form-check-input"
                                  value="1"
                                  checked={userData.user_status === "1"}
                                  onChange={handleStatusChange}
                                />
                                Active
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="user_status"
                                  className="form-check-input"
                                  value="0"
                                  checked={userData.user_status === "0"}
                                  onChange={handleStatusChange}
                                />
                                Inactive
                              </label>
                            </div>
                          </div>
                        </div>


                        {/* Name */}
                        <div className="col-12 col-md-6 col-xl-12">
                          <div className="form-group local-forms">
                            <label>Name <span className="login-danger">*</span></label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_name"
                              value={userData.user_name || ""}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>

                        {/* Contact and Email */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Mobile <span className="login-danger">*</span></label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_contact"
                              value={userData.user_contact || ""}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Email <span className="login-danger">*</span></label>
                            <input
                              className="form-control"
                              type="email"
                              name="user_email"
                              value={userData.user_email || ""}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>

                        {/* Biography */}
                        <div className="col-12 col-sm-12">
                          <div className="form-group local-forms">
                            <label>Biography</label>
                            <textarea
                              className="form-control"
                              rows={3}
                              cols={30}
                              name="user_biography"
                              value={userData.user_biography || ""}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>

                        {/* Designation, Qualification, Department */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>Designation <span className="login-danger">*</span></label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_designation"
                              value={userData.user_designation || ""}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>Qualification <span className="login-danger">*</span></label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_qualification"
                              value={userData.user_qualification || ""}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>Department (Type to search and select)<span className="login-danger">*</span></label>
                            <Select
                              value={selectedDepartment}
                              onChange={handleDepartmentChange}
                              options={departmentOptions}
                              components={{ IndicatorSeparator: () => null }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused ? "#2e37a4" : "rgba(46, 55, 164, 0.1)",
                                  boxShadow: "none",
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                menu: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              menuPortalTarget={document.body}
                            />
                          </div>
                        </div>

                        {/* Experience and Specialization */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>Teaching Experience <span className="login-danger">*</span></label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_teaching_experience"
                              value={userData.user_teaching_experience || ""}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>Industrial Experience</label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_industrial_experience"
                              value={userData.user_industrial_experience || ""}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>Specialization</label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_specialization"
                              value={userData.user_specialization || ""}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>

                        {/* Publications and Research */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>International Publications</label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_international_publication"
                              value={userData.user_international_publication || ""}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>Domestic Publications</label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_domestic_publication"
                              value={userData.user_domestic_publication || ""}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>Research Projects</label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_research_project"
                              value={userData.user_research_project || ""}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>

                        {/* Social Links */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Facebook profile link</label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_facebook_link"
                              value={userData.user_facebook_link || ""}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Linkedin profile link</label>
                            <input
                              className="form-control"
                              type="text"
                              name="user_linkedin_link"
                              value={userData.user_linkedin_link || ""}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>

                        {/* Submit Buttons */}
                        <div className="col-12">
                          <div className="text-end">
                            <button
                              type="submit"
                              className="btn btn-primary me-2"
                              disabled={loading}
                            >
                              {loading ? 'Updating...' : 'Submit'}
                            </button>
                            <Link
                              to="/profile"
                              className="btn btn-secondaryi"
                            >
                              Cancel
                            </Link>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUser;